"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInputState = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var i18n_1 = require("../../i18n");
var input_state_1 = require("./input.state");
var RE_NUMBER = /^\s*[+-]?((\.\d+)|(\d+(\.\d+)?))$/;
var NumberInputState = /** @class */ (function (_super) {
    tslib_1.__extends(NumberInputState, _super);
    function NumberInputState(label, precision, minimumInputPrecision, options) {
        if (precision === void 0) { precision = NumberInputState.DEFAULT_PRECISION; }
        if (minimumInputPrecision === void 0) { minimumInputPrecision = NumberInputState.DEFAULT_MINIMUM_INPUT_PRECISION; }
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, label) || this;
        _this.hideZero = false;
        _this.onBlurCallback = function (e) { return undefined; };
        _this.onInputCallback = function (e) { return undefined; };
        _this.precision = precision;
        _this.minimumInputPrecision = minimumInputPrecision;
        if (options.onblur) {
            _this.onBlurCallback = options.onblur;
        }
        if (options.oninput) {
            _this.onInputCallback = options.oninput;
        }
        return _this;
    }
    NumberInputState.equal = function (value1, value2, precision) {
        if (value1 == null || value2 == null || isNaN(value1) || isNaN(value2)) {
            return value1 === value2;
        }
        return value1.toFixed(precision) === value2.toFixed(precision);
    };
    NumberInputState.prototype.formatInputValue = function (val) {
        if (val == null || isNaN(val)) {
            return null;
        }
        var roundedValue = core_shared_1.IkeUnit.round(val, this.precision);
        if (this.hideZero && roundedValue === 0) {
            return null;
        }
        return String(roundedValue);
    };
    NumberInputState.prototype.parseInputValue = function (val) {
        var num = this.parseNumber(val);
        if (num == null) {
            this.setError(null);
            return null;
        }
        if (isNaN(num)) {
            this.setError(i18n_1.T.NUMBER_INVALID);
            return null;
        }
        var splitVal = val.split('.');
        //in order to ensure that splitVal.length is at least two, we had an empty string at the end
        splitVal.push('');
        if (splitVal[1].length < this.minimumInputPrecision) {
            this.setError((0, i18n_1.Translate)(i18n_1.T.NUMBER_IMPRECISE, { minimumInputPrecision: this.minimumInputPrecision }));
            return null;
        }
        this.setError(null);
        if (this.hideZero && num === 0) {
            return null;
        }
        return num;
    };
    NumberInputState.prototype.parseNumber = function (val) {
        if (val.trim().length === 0) {
            return null;
        }
        if (val.match(RE_NUMBER) == null) {
            return NaN;
        }
        return Number(val);
    };
    NumberInputState.prototype.onBlur = function (e) {
        this.onBlurCallback(e);
    };
    NumberInputState.prototype.onInput = function (e) {
        this.onInputCallback(e);
    };
    NumberInputState.DEFAULT_PRECISION = 3;
    NumberInputState.DEFAULT_MINIMUM_INPUT_PRECISION = 0;
    return NumberInputState;
}(input_state_1.InputState));
exports.NumberInputState = NumberInputState;
//# sourceMappingURL=number.input.state.js.map